var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-2.5 w-full border-4 justify-center items-center gap-2.5 inline-flex relative",
    class: [_vm.borderColor, _vm.bgColor, _vm.rounded, {
      'cursor-not-allowed': _vm.disabled,
      'cursor-pointer': !_vm.disabled
    }],
    attrs: {
      "role": "radio",
      "tabindex": "0",
      "aria-checked": _vm.selected,
      "aria-label": _vm.getAccessibleText(_vm.answer)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('select');
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('select');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$emit('select');
      }]
    }
  }, [_vm.selected && _vm.answer === 1 ? _c('button', {
    staticClass: "absolute bottom-0 left-0",
    attrs: {
      "aria-label": "Désélectionner la réponse"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('unselect');
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        return _vm.$emit('unselect');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        return _vm.$emit('unselect');
      }]
    }
  }, [_c('Icon', {
    attrs: {
      "aria-hidden": true,
      "width": _vm.answerIconSize / 2,
      "height": _vm.answerIconSize / 2,
      "fill-color": _vm.fillColor,
      "no-title": ""
    }
  }, [_c('IconTimesCircle')], 1)], 1) : _vm._e(), _vm._v(" "), _c('Icon', {
    attrs: {
      "width": _vm.answerIconSize,
      "height": _vm.answerIconSize,
      "fill-color": _vm.fillColor,
      "aria-hidden": "true"
    }
  }, [_c(_vm.faceIcon, {
    tag: "component"
  })], 1), _vm._v(" "), _vm.selected && _vm.answer !== 1 ? _c('button', {
    staticClass: "absolute bottom-0 right-0",
    attrs: {
      "aria-label": "Désélectionner la réponse"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.$emit('unselect');
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.stopPropagation();
        return _vm.$emit('unselect');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.stopPropagation();
        return _vm.$emit('unselect');
      }]
    }
  }, [_c('icon', {
    attrs: {
      "aria-hidden": true,
      "width": _vm.answerIconSize / 2,
      "height": _vm.answerIconSize / 2,
      "fill-color": _vm.fillColor,
      "no-title": ""
    }
  }, [_c('IconTimesCircle')], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }